import { render, staticRenderFns } from "./ComboMealItems.vue?vue&type=template&id=2fd154e4"
import script from "./ComboMealItems.vue?vue&type=script&lang=ts"
export * from "./ComboMealItems.vue?vue&type=script&lang=ts"
import style0 from "./ComboMealItems.vue?vue&type=style&index=0&id=2fd154e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports